import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Input, Col, Row, Container, Table } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../../components/DataRow';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class TableScreen extends React.Component {
    constructor(props) {
        super(props);
        const queries = utils.parseQueryParams(this.props);
        this.state = {
            selectedFieldId: this.props.match.params.field_id || null,
            table: {
                id: parseInt(this.props.match.params.table_id, 10) || '',
                code_name: '',
                description: '',
                name: '',
                fields: [],
            },
            originalTable: {},
            isGrantingPermission: queries.is_granting_permission || false,
            userId: queries.user_id || 0,
        }
        this.search = _.debounce(this.search, 500)
    }
    componentWillMount() {
        this.getTable();
    }
    componentDidMount = () => {
        
    }
    setSearchKeyword(value) {
        this.setState({ searchKeyword: value }, this.search);
    }
    getTable() {
        const { table, selectedFieldId, isGrantingPermission, userId } = this.state;

        let uri = `table/${table.id}`;
        if (userId && isGrantingPermission) {
            uri = `${uri}?permission_user_id=${userId}`;
        }

        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                const table = response.table;

                // Move the selected field to top of the list
                if (selectedFieldId) {
                    let selectedField = null;
                    table.fields.map(field => {
                        if (field.id == selectedFieldId) {
                            selectedField = field;
                        }
                    })
                    if (selectedField) {
                        table.fields = table.fields.filter(field => field.id != selectedField.id);
                        table.fields.unshift(selectedField);
                    };
                }

                this.setState({ table, originalTable: table });
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    search() {
        const { searchKeyword, table, originalTable } = this.state;
        if (searchKeyword !== '' && searchKeyword) {
            api.fetchAPI({
                method: 'get',
                uri: `search?q=${searchKeyword}&index=field&parent_field_name=table_id&parent_id=${table.id}`,
                success: (response) => {
                    if (response.status === 'ok') {
                        const fieldsMatched = [];
                        const originalTableCopy = {...originalTable};
                        response.results.map(returnedField => {
                            if (returnedField.object_type === 'field') {
                                const fieldMatched = originalTableCopy.fields.filter(field => field.id == returnedField.id);
                                if (fieldMatched && fieldMatched.length > 0) {
                                    fieldsMatched.push(fieldMatched[0]);
                                }
                            }
                        });
                        table.fields = fieldsMatched;
                        this.setState({ table });
                    }
                },
                error: (error) => {
                  console.error(error);
                }
            });
        } else {
            this.getTable();
        }
        this.setState({ isSearching: false });
    }
    render() {
        const { table, selectedFieldId, isGrantingPermission, userId } = this.state;
        document.title = `${table.code_name} | DataDex`;
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h1 className="main-object-code_name">{table.code_name}</h1>
                        <span className="main-object-type">{table.object_type}</span>
                    </Col>
                    <Col xs={12}>
                        <br />
                        <p>{table.name}</p>
                        <p>{table.description}</p>
                    </Col>
                </Row>
                {table.permissions && table.permissions.edit &&
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Button tag={Link} to={`/table/${table.id}/edit`} color="primary">
                                    Edit
                                </Button>{' '}
                            </FormGroup>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <Input
                                type="text"
                                placeholder="Search for fields..."
                                onChange={(e) => this.setSearchKeyword(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={12}>
                        <p>Table fields</p>
                        <Table striped hover responsive>
                            <thead>
                                <tr>
                                    <th>Field name</th>
                                    <th>Data type</th>
                                    <th>Description</th>
                                    <th>Tag</th>
                                    {isGrantingPermission &&
                                        <th>Allow</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {table.fields.map(field =>
                                    <DataRow
                                        key={field.id}
                                        dataObject={field}
                                        shouldHighlight={parseInt(field.id, 10) === parseInt(selectedFieldId, 10)}
                                        isGrantingPermission={isGrantingPermission}
                                        userId={userId}
                                    />
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/Table/index.js